import http from "../../helpers/http-common";

class ClassroomDataService {
    getAll() {
        return http.get("/classrooms");
    }

    get(id) {
        return http.get(`/classrooms/${id}`);
    }

    create(data) {
        return http.post("/classrooms", data);
    }

    update(id, data) {
        return http.put(`/classrooms/${id}`, data);
    }

    delete(id) {
        return http.delete(`/classrooms/${id}`);
    }

    deleteAll() {
        return http.delete('/classrooms');
    }

    findByName(name) {
        return http.get(`/classrooms?name=${name}`);
    }
}

export default new ClassroomDataService();
